import React, { useEffect, useState } from 'react';
import { ShoppingCartIcon } from 'lucide-react';
const proofs = [{
  name: 'María',
  city: 'Buenos Aires'
}, {
  name: 'Luciana',
  city: 'Córdoba'
}, {
  name: 'Sofía',
  city: 'Rosario'
}, {
  name: 'Camila',
  city: 'Mendoza'
}, {
  name: 'Valentina',
  city: 'La Plata'
}, {
  name: 'Florencia',
  city: 'Tucumán'
}, {
  name: 'Carolina',
  city: 'Mar del Plata'
}, {
  name: 'Daniela',
  city: 'Salta'
}, {
  name: 'Julieta',
  city: 'Santa Fe'
}, {
  name: 'Agustina',
  city: 'Neuquén'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const showPopup = () => {
      setCurrent(Math.floor(Math.random() * proofs.length));
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    };
    const initialDelay = setTimeout(() => {
      showPopup();
      const interval = setInterval(() => {
        showPopup();
      }, Math.random() * 10000 + 15000);
      return () => clearInterval(interval);
    }, 8000);
    return () => clearTimeout(initialDelay);
  }, []);
  const proof = proofs[current];
  return <div className={`fixed bottom-4 left-4 z-50 bg-white rounded-xl shadow-2xl border border-gray-200 px-4 py-3 max-w-[320px] flex items-center gap-3 transition-all duration-300 ease-out ${visible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0 pointer-events-none'}`} data-id="element-364">
      <div className="bg-green-100 rounded-full p-2 flex-shrink-0" data-id="element-365">
        <ShoppingCartIcon className="w-5 h-5 text-green-600" data-id="element-366" />
      </div>
      <div data-id="element-367">
        <p className="text-sm font-semibold text-gray-900" data-id="element-368">
          {proof.name} de {proof.city}
        </p>
        <p className="text-xs text-gray-500" data-id="element-369">acaba de comprar el MegaPack</p>
        <p className="text-xs text-green-600 font-medium mt-0.5" data-id="element-370">
          Hace unos momentos
        </p>
      </div>
    </div>;
}